import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IVariantPersonaDiscountItem,
  IVariantPersonaDiscountsResponse,
} from "@/api_framework/api_modals/Inventory";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export const useVariantPersonaDiscountsAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const [variants, setVariants] = useState<IVariantPersonaDiscountItem[]>([]);
  const [productName, setProductName] = useState<string>("");

  const execute = useCallback(
    async (veticVariantId: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(`${INVENTORY_MODULE?.VARIANT_PERSONA_DISCOUNTS_API?.baseURL}${veticVariantId}/`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IVariantPersonaDiscountsResponse>) => {
            if (res.data.status === true) {
              setVariants(res.data.data?.variants ?? []);
              setProductName(res.data.data?.product_name ?? "");
            } else {
              setVariants([]);
              setProductName("");
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            setVariants([]);
            setProductName("");
            captureError(e);
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );

  return { execute, variants, setVariants, productName };
};
